import { formatarValorMonetario } from "./masks";
import tratativaDeDatas from "./tratativaDeDatas";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable'

function extrairNomesId(objeto: any, formatos?: { [key: string]: string }): string {
    const novoObjeto = { ...objeto };

    for (const chave in novoObjeto) {
        if (typeof novoObjeto[chave] === 'object' && novoObjeto[chave] !== null) {
            if ('id' in novoObjeto[chave] || 'nome' in novoObjeto[chave]) {
                novoObjeto[chave] = `${'id' in novoObjeto[chave] ? novoObjeto[chave].id + " - " : ""} ${'nome' in novoObjeto[chave] ? novoObjeto[chave].nome : ""}`;
            } else {
                novoObjeto[chave] = '';
            }
        } else if (formatos) {
            const formato = formatos[chave] || "";
            novoObjeto[chave] = tratativaDeValores(novoObjeto[chave], formato);
        }
    }
    return novoObjeto;

}

export default function extrairNomesIdArray(array: any[], formatos?: { [key: string]: string }): any[] {
    return array.map((objeto) => extrairNomesId(objeto, formatos));
}

const tratativaDeValores = (valor: any, formato: string): string => {
    if (valor === null || valor === undefined) return "-"

    let valorFormatado = valor;
    switch (formato) {
        case "monetario":
            valorFormatado = formatarValorMonetario(Number(valor))
            break

        case "afirmacao/negacao":
            let valorBooleano: Boolean = valor
            if(valor === 'string') valorFormatado = Boolean(Number(valor))
            valorFormatado = valorBooleano ? "Sim" : "Não"
            break

        case "data":
            valorFormatado = tratativaDeDatas(valor)
            break
    }

    return valorFormatado
}

export const generatePDFTable = (
    tableData: { [key: string]: string }[],
    headers: string[],
    filename: string,
    options?: { title?: string; info?: Array<{ label: string; value: string }>; rightAlignHeaders?: string[] }
) => {
    const doc = new jsPDF({
        orientation: 'landscape',
    });

    let startY = 20;
    if (options?.title) {
        doc.setFontSize(14);
        doc.text(options.title, 14, 12);
        startY = 18;
    }

    if (options?.info && options.info.length > 0) {
        doc.setFontSize(10);
        let y = startY + 2;
        options.info.forEach((item) => {
            doc.text(`${item.label}: ${item.value}`, 14, y);
            y += 5;
        });
        startY = Math.max(y, 20);
    }

    const rowData = tableData.map((row) => {
        return headers.map((header) => row[header] || '');
    });

    const columnStyles: any = {}
    if (options?.rightAlignHeaders && options.rightAlignHeaders.length > 0) {
        headers.forEach((h, idx) => {
            if (options.rightAlignHeaders?.includes(h)) columnStyles[idx] = { halign: 'right' }
        })
    }

    autoTable(doc, {
        head: [headers],
        body: rowData,
        startY,
        styles: {
            fontSize: 7,
            overflow: 'linebreak',
            cellPadding: 1,
        },
        headStyles: {
            fillColor: [27, 94, 32], 
            textColor: [255, 255, 255], 
        },
        columnStyles,
        didParseCell: (data) => {
            if (data.section === 'head' && options?.rightAlignHeaders && options.rightAlignHeaders.length > 0) {
                const headerText = String(data.cell.raw ?? '')
                if (options.rightAlignHeaders.includes(headerText)) {
                    data.cell.styles.halign = 'right'
                }
            }
        }
    });

    doc.save(filename + '.pdf');
};